import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { PortalHeader } from 'components'
import { ARTIST_PORTAL_ROUTE } from 'config'
import { useCommunity } from 'utils'

const propTypes = {
  children: PropTypes.node,
}

const defaultProps = {}

function Layout({ children }) {
  const {
    defaultBranding: { dashboardHeader },
  } = useCommunity()
  return (
    <div>
      <PortalHeader
        title="Home"
        backgroundImage={dashboardHeader}
        links={[
          { name: 'Dashboard', path: ARTIST_PORTAL_ROUTE + '/dashboard' },
          {
            name: 'artlook Map Summary',
            path: ARTIST_PORTAL_ROUTE + '/summary',
          },
        ]}
      ></PortalHeader>
      <div className="content-block-container">{children}</div>
    </div>
  )
}

Layout.propTypes = propTypes

Layout.defaultProps = defaultProps

function mapStateToProps() {
  return {}
}

export default compose(connect(mapStateToProps))(Layout)
